import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Address, BillingAccount, DataCustomerAffiliate, DataCustomerBOperator, DataCustomerCountry, DataCustomerHq, DataCustomerLeadOperator } from '../creazione-nuovo-customer/creazione-nuovo-customer-costants';

@Component({
  selector: 'app-customer-affiliate',
  templateUrl: './customer-affiliate.component.html',
  styleUrls: ['./customer-affiliate.component.css']
})
export class CustomerAffiliateComponent implements OnInit {

  @Input() customerDto: DataCustomerLeadOperator;
  @Input() isDisableFormAffiliate: boolean;
  @Input() tendinaAgreements: any[];

  @Output() changeCreationStepCustomerDataAffiliateItemEvent = new EventEmitter<string>();

  @Output() updateCustomerDataAffiliateItemEvent = new EventEmitter<DataCustomerLeadOperator>();
  @Output() saveCustomerAffiliateEvent = new EventEmitter<DataCustomerLeadOperator>();
  @Output() previousStepEvent = new EventEmitter<string>();

  listCountry: DataCustomerCountry[] = [];
  listBOperator: DataCustomerBOperator[] = [];
  ngOnDestroy: () => void;



  constructor() { }

  ngOnInit(): void {
    this.initializeCustomerDataAffiliateForm();

  }

  initializeCustomerDataAffiliateForm() {
    this.listBOperator = this.customerDto ? this.customerDto.listBOperator : [];
    for (let operatorB of this.listBOperator) {
      if (operatorB && operatorB.listCountry && operatorB.listCountry.length > 0) {
        for (let country of operatorB.listCountry) {
          if (country.listAffiliate.length == 0) {


            let affiliate: DataCustomerAffiliate = {
              affiliateId: '',
              affiliateName: '',
              countryCustomerId: country.countryCustomerId,
              globalCustomerId: country.globalCustomerId,
              country: '',
              customerBillingAccount: [{
                id: '',
                address: {
                  name: '',
                  city: '',
                  country: '',
                  postCode: '',
                  streetName: '',
                  streetNr: '',
givenName: '',
title: ''
                }
              }],
              deliveryAddress: {
                name: '',
                city: '',
                country: '',
                postCode: '',
                streetName: '',
                streetNr: '',
givenName: '',
title: ''
              },
              localAgreement: country.localAgreement,
              operator: country.operator,
              listDepartment: [],
              telephoneNumber:''
            }
            country.listAffiliate.push(affiliate);
          } else {

            for (let aff of country.listAffiliate) {
              if (!aff.customerBillingAccount) {
                let arr: BillingAccount[] = [
                  {
                    id: '',
                    address: {
                      name: '',
                      city: '',
                      country: '',
                      postCode: '',
                      streetName: '',
                      streetNr: '',
givenName: '',
title: ''
                    }
                  }
                ];
                aff.customerBillingAccount = arr;
              } else {
                for (let acc of aff.customerBillingAccount) {
                  if (!acc.address) {
                    acc.address = {
                      name: '',
                      city: '',
                      country: '',
                      postCode: '',
                      streetName: '',
                      streetNr: '',
givenName: '',
title: ''
                    }
                  }
                }
              }
              if (!aff.deliveryAddress) {
                aff.deliveryAddress = {
                  name: '',
                  city: '',
                  country: '',
                  postCode: '',
                  streetName: '',
                  streetNr: '',
givenName: '',
title: ''
                }
              }
            }
          }
        }
      }

    }

  }

  backToStepCustomerDataCountry() {
    this.updateCustomerAffiliateData();
    this.previousStepEvent.emit("customer-data-country");
  }

  goToStepCustomerDepartment() {
    this.updateCustomerAffiliateData();
    this.changeCreationStepCustomerDataAffiliateItemEvent.emit("customer-data-department");
  }

  updateCustomerAffiliateData() {
    if (this.listBOperator.length > 0) {
      this.customerDto.listBOperator = this.listBOperator;
    }
    this.updateCustomerDataAffiliateItemEvent.emit(this.customerDto);
  }

  resetForm() {
    for (let operatorB of this.listBOperator) {
      if (operatorB && operatorB.listCountry && operatorB.listCountry.length > 0) {
        for (let elem of operatorB.listCountry) {
          if (elem.listAffiliate.length > 0) {
            for (let affiliate of elem.listAffiliate) {
              affiliate.affiliateId = '';
              affiliate.customerBillingAccount = [{
                id: '',
                address: {
                  name: '',
                  city: '',
                  country: '',
                  postCode: '',
                  streetName: '',
                  streetNr: '',
givenName: '',
title: ''
                }
              }];
              affiliate.deliveryAddress = {
                name: '',
                city: '',
                country: '',
                postCode: '',
                streetName: '',
                streetNr: '',
givenName: '',
title: ''
              };
              affiliate.affiliateName = '';
              affiliate.localAgreement = elem.localAgreement;
              affiliate.operator = operatorB.bOperator;
            }
          }
        }
      }
    }
  }

  customerDataAffiliateFormDisabled() {
    let result: boolean = false;
    let numOfAffiliate: number = 0;
    for (let operatorB of this.listBOperator) {
      if (operatorB && operatorB.listCountry && operatorB.listCountry.length > 0) {
        for (let elem of operatorB.listCountry) {
          if (elem.listAffiliate.length > 0) {
            for (let affiliate of elem.listAffiliate) {
              numOfAffiliate++;
              if (!affiliate.affiliateId ||
                !this.checkValidationdeliveryAddress(affiliate.deliveryAddress) || !affiliate.affiliateName) {
                return true;
              }
            }
          }
        }
      }
    }

    if (numOfAffiliate == 0) {
      return true;
    }

    return result;
  }

  saveCustomer() {
    this.updateCustomerAffiliateData();
    this.saveCustomerAffiliateEvent.emit(this.customerDto);
  }

  disableForm(): boolean {
    return this.isDisableFormAffiliate;
  }

  getCountryName(country?: DataCustomerCountry) {
    if (country && !country.countryName) {
      return "Country";
    } else if (country && country.countryName) {
      return "Country " + country.countryName;
    } else {
      return "";
    }
  }

  getAffiliateName(affiliate: DataCustomerAffiliate) {
    if (affiliate.affiliateId) {
      return "Affiliate " + affiliate.affiliateName + " ( " + affiliate.affiliateId + " )";

    } else {
      return "Affiliate " + affiliate.affiliateName;

    }
  }

  viewAddAffiliateZeroAffiliate(country: DataCustomerCountry) {
    if (country.listAffiliate.length == 0) {
      return true;
    } else {
      return false;
    }


  }

  viewAddAffiliate(country: DataCustomerCountry, affiliate: DataCustomerAffiliate) {
    let index = country.listAffiliate.indexOf(affiliate);
    if (index == (country.listAffiliate.length - 1)) {
      return true;
    } else {
      return false;
    }
  }

  addAffiliateToCountry(country: DataCustomerCountry) {
    let data: DataCustomerAffiliate = {
      affiliateId: '',
      customerBillingAccount: [{
        id: '',
        address: {
          name: '',
          city: '',
          country: '',
          postCode: '',
          streetName: '',
          streetNr: '',
givenName: '',
title: ''
        }
      }],
      deliveryAddress: {
        name: '',
        city: '',
        country: '',
        postCode: '',
        streetName: '',
        streetNr: '',
givenName: '',
title: ''
      },
      affiliateName: '',
      localAgreement: country.localAgreement,
      listDepartment: [],
      countryCustomerId: country.countryCustomerId,
      globalCustomerId: country.globalCustomerId,
      operator: country.operator,
      country: '',
      telephoneNumber:''
    }
    country.listAffiliate.push(data);
    console.log(this.listCountry);
  }





  removeAffiliate(country: DataCustomerCountry, affiliate: DataCustomerAffiliate) {
    let index = country.listAffiliate.indexOf(affiliate);
    country.listAffiliate.splice(index, 1);
  }



  checkValidationdeliveryAddress(address: Address) {
    let result: boolean = true;
    if (!address || !address.city || !address.country || !address.name
      || !address.postCode || !address.streetName
      || !address.streetNr) {
      return false;
    }


    return result;
  }





  addBillingAccount(affiliate: DataCustomerAffiliate) {
    let data: BillingAccount = {
      id: '',
      address: {
        name: '',
        city: '',
        country: '',
        postCode: '',
        streetName: '',
        streetNr: '',
givenName: '',
title: ''
      }
    };
    affiliate.customerBillingAccount.push(data);


  }

  viewAddBillingAccount(account: BillingAccount, affiliate: DataCustomerAffiliate) {
    let index = affiliate.customerBillingAccount.indexOf(account);
    if (index == (affiliate.customerBillingAccount.length - 1)) {
      return true;
    } else {
      return false;
    }
  }





  removeBillingAccount(affiliate: DataCustomerAffiliate, billingAccount: BillingAccount) {
    let index = affiliate.customerBillingAccount.indexOf(billingAccount);
    affiliate.customerBillingAccount.splice(index, 1);
  }



  viewAddBillingAccountZeroBillingAccount(affiliate: DataCustomerAffiliate) {
    if (affiliate.customerBillingAccount && affiliate.customerBillingAccount.length == 0) {
      return true;
    } else {
      return false;
    }
  }

  isDisableLocalAgreement(country: DataCustomerCountry) {
    if (country.localAgreement) {
      return true;
    } else {
      return false;
    }

  }

  getBOperatorId(bOperator?: DataCustomerBOperator) {
    if (bOperator && !bOperator.bOperator) {
      return "B Operator";
    } else if (bOperator && bOperator.bOperator) {
      return "B Operator " + bOperator.bOperator;
    } else {
      return "";
    }
  }

  onChangeLocalAgreement(newValue: string, bOperator: DataCustomerBOperator,
    countrySelected: DataCustomerCountry, affiliateSelected: DataCustomerAffiliate) {

    if (this.listBOperator && this.listBOperator.length > 0) {
      let bOp = this.listBOperator.find(element => element.bOperatorGlobalCustomerId == bOperator.bOperatorGlobalCustomerId);
      if (bOp && bOp.listCountry && bOp.listCountry.length > 0) {
        let country = bOp.listCountry.find(elem => elem.countryCustomerId == countrySelected.countryCustomerId
          && elem.countryName == countrySelected.countryName);
        if (country && country.listAffiliate && country.listAffiliate.length > 0) {
          let affiliate = country.listAffiliate.find(aff => aff.affiliateId == affiliateSelected.affiliateId);
          if (affiliate && affiliate.listDepartment && affiliate.listDepartment.length > 0) {
            for (let dep of affiliate.listDepartment) {
              dep.localAgreement = newValue;
            }
          }
        }
      }
    }
    this.updateCustomerAffiliateData();
  }

  customerDataAffiliateFormNextDisabled() {
    let result: boolean = false;
    let numOfAffiliate: number = 0;
    for (let operatorB of this.listBOperator) {
      if (operatorB && operatorB.listCountry && operatorB.listCountry.length > 0) {
        for (let elem of operatorB.listCountry) {
          if (elem.listAffiliate.length > 0) {
            for (let affiliate of elem.listAffiliate) {
              numOfAffiliate++;
              if (!affiliate.affiliateId ||
                !this.checkValidationdeliveryAddress(affiliate.deliveryAddress) || !affiliate.affiliateName) {
                return true;
              }
            }
          }
        }
      }
    }

    if (numOfAffiliate == 0) {
      return true;
    }

    return result;
  }


}
